module.exports = __webpack_public_path__ + "./docs/img/embeddable.310a861e37e27b22e7bdfe3a41e94566.svg";